// import styled from 'styled-components'
// import {Link} from 'react-router-dom'

// export const VideoCardContainer = styled.li`
//   display: flex;
//   flex-direction: column;
//   width: 300px;
//   list-style-type: none;
//   cursor: pointer;
//   margin: 25px;
//   background-color: ${props => props.bgColor};
//   border-radius: 8px;
//   overflow: hidden;
// `

// export const VideoCardBottomContainer = styled.div`
//   display: flex;
//   align-items: center;
//   padding: 10px;
// `

// export const ThumbnailImage = styled.img`
//   width: 100%;
//   border-bottom: 1px solid #d1d5db;
// `

// export const ProfileImage = styled.img`
//   height: 40px;
//   width: 40px;
//   border-radius: 50%;
//   margin-right: 10px;
// `

// export const VideoDetailsContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   margin-left: 10px;
// `

// export const VideoDetailsText = styled.p`
//   color: ${props => props.color};
//   font-family: 'Roboto', sans-serif;
//   font-size: 12px;
//   font-weight: bold;
//   margin: 2px 0;
// `

// export const NavLink = styled(Link)`
//   color: #1e293b;
//   text-decoration: none;
// `

import styled from 'styled-components'
import {Link} from 'react-router-dom'

export const VideoCardContainer = styled.li`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 320px;
  list-style-type: none;
  cursor: pointer;
  margin: 20px;
  background-color: ${props => props.bgColor};
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }

  @media screen and (min-width: 768px) {
    max-width: 280px;
  }

  @media screen and (min-width: 1024px) {
    max-width: 300px;
  }
`

export const VideoCardBottomContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 15px;
  background-color: ${props => props.bgColor};
`

export const ThumbnailImage = styled.img`
  width: 100%;
  height: auto;
  border-bottom: 1px solid #d1d5db;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.9;
  }
`

export const ProfileImage = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  margin-right: 12px;
  object-fit: cover;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`

export const VideoDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 10px;

  @media screen and (min-width: 768px) {
    margin-left: 12px;
  }

  @media screen and (min-width: 1024px) {
    margin-left: 14px;
  }
`

export const VideoDetailsText = styled.p`
  color: ${props => props.color};
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  margin: 4px 0;
  line-height: 1.5;
  transition: color 0.3s ease;

  &:first-of-type {
    font-size: 16px;
    font-weight: bold;
  }

  @media screen and (min-width: 768px) {
    font-size: 13px;

    &:first-of-type {
      font-size: 15px;
    }
  }
`

export const NavLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  display: block;
  transition: color 0.3s ease;

  &:hover {
    color: ${props => (props.isDarkTheme ? '#e0e0e0' : '#1a1a1a')};
  }
`